<p-toast position="top-right"></p-toast>
<input
  *ngIf="isClientContext"
  #fileInput
  type="file"
  hidden
  [attr.multiple]="multiAccept ? '' : null"
  accept=".pdf,application/pdf"
  (change)="onFilePicked($event)"
/>

<div class="docs-wrap">
  <!-- Header -->
  <div class="info-card docs-header">
    <div class="card-header">
      <i class="fa-solid fa-folder-open text-indigo-600"></i>
      <h3>{{ isClientContext ? 'Documentación del cliente' : 'Copia del expediente en el arrendamiento' }}</h3>
      <span
        class="pending-pill"
        *ngIf="isClientContext && totalPendingCount > 0"
        title="Archivos subidos por el cliente o brokers en espera de revisión"
      >
        <i class="fa-solid fa-hourglass-half"></i> {{ totalPendingCount }} por revisar
      </span>
      <span class="completeness-pill">{{ uploadedDocs }}/{{ totalDocs }} · {{ completeness }}%</span>
    </div>
    <div class="progress-track"><div class="progress-fill" [style.width.%]="completeness"></div></div>
  </div>

  <!-- Sub-tabs segmentados: Titular | Avales | + -->
  <div class="seg-tabs">
    <button class="seg" [class.active]="activeTab === 'holder'" (click)="selectTab('holder')">
      <i class="fa-solid fa-user"></i> Titular
      <span class="seg-pending" *ngIf="isClientContext && holderPendingCount > 0" [title]="holderPendingCount + ' por revisar'">{{
        holderPendingCount
      }}</span>
    </button>
    <button *ngFor="let g of guarantors; let i = index" class="seg" [class.active]="activeTab === g._id" (click)="selectTab(g._id)">
      <i class="fa-solid fa-user-shield"></i> {{ guarantorLabel(g, i) }} · {{ g.type }}
      <span
        class="seg-pending"
        *ngIf="isClientContext && guarantorPendingCount(g) > 0"
        [title]="guarantorPendingCount(g) + ' por revisar'"
        >{{ guarantorPendingCount(g) }}</span
      >
      <ng-container *ngIf="isClientContext">
        <i
          *appIfHasPermission="['documents', 'delete']"
          class="fa-solid fa-xmark seg-remove"
          (click)="$event.stopPropagation(); removeGuarantor(g)"
        ></i>
      </ng-container>
    </button>
    <ng-container *ngIf="isClientContext">
      <button *appIfHasPermission="['documents', 'update']" class="seg seg-add" (click)="openAddGuarantor()">
        <i class="fa-solid fa-plus"></i>
      </button>
    </ng-container>
  </div>

  <!-- Lista de documentos del tab activo, agrupada por sección -->
  <div class="info-card doc-list" *ngIf="catalog; else loadingTpl">
    <ng-container *ngFor="let sec of groupedEntries">
      <button
        type="button"
        class="doc-section-head"
        [class.is-collapsed]="isSectionCollapsed(sec.key)"
        (click)="toggleSection(sec.key)"
        *ngIf="sectionStats(sec.entries) as st"
      >
        <i class="fa-solid fa-chevron-down sec-chevron"></i>
        <span class="sec-label">{{ sec.label }}</span>
        <span class="sec-pending" *ngIf="isClientContext && st.pendingCount > 0" title="Archivos en espera de revisión en esta sección">
          <i class="fa-solid fa-hourglass-half"></i> {{ st.pendingCount }} por revisar
        </span>
        <!-- «Otros» no se cuenta contra nada: no hay anillo que llenar, solo cuántos archivos hay. -->
        <span class="sec-meter is-optional" *ngIf="st.optionalOnly">
          <span class="sec-count">{{ st.fileCount }} {{ st.fileCount === 1 ? 'archivo' : 'archivos' }}</span>
        </span>
        <span
          class="sec-meter"
          *ngIf="!st.optionalOnly"
          [class.empty]="st.filled === 0"
          [class.complete]="st.total > 0 && st.filled === st.total"
        >
          <span class="sec-ring-wrap">
            <svg class="sec-ring" viewBox="0 0 24 24" width="16" height="16" *ngIf="!(st.total > 0 && st.filled === st.total)">
              <circle class="ring-bg" cx="12" cy="12" r="9"></circle>
              <circle
                class="ring-fg"
                cx="12"
                cy="12"
                r="9"
                [attr.stroke-dasharray]="ringC"
                [attr.stroke-dashoffset]="ringC * (1 - st.pct / 100)"
              ></circle>
            </svg>
            <i class="fa-solid fa-check sec-check-icon" *ngIf="st.total > 0 && st.filled === st.total"></i>
          </span>
          <span class="sec-count">{{ st.filled }} de {{ st.total }}</span>
        </span>
      </button>
      <div class="doc-section-body" [class.collapsed]="isSectionCollapsed(sec.key)">
        <div class="doc-section-body-inner">
          <ng-container *ngFor="let entry of sec.entries">
            <!-- SINGLE (inerte: el catálogo es 100% multi-archivo) -->
            <div
              class="doc-row"
              *ngIf="!entry.isArray"
              [class.has-file]="getSingle(entry.field).url"
              [class.overdue]="dueInfo(entry.field)?.overdue"
            >
              <div class="row-left">
                <span class="doc-icon" [class.filled]="getSingle(entry.field).url">
                  <i
                    class="fa-solid"
                    [ngClass]="getSingle(entry.field).url ? fileIcon(getSingle(entry.field).url) : 'fa-file-circle-plus'"
                  ></i>
                </span>
                <div class="row-text">
                  <span class="doc-name">{{ entry.label }}</span>
                  <span class="doc-sub" *ngIf="getSingle(entry.field).url">{{ fileName(getSingle(entry.field).url) }}</span>
                  <span class="doc-sub muted" *ngIf="!getSingle(entry.field).url && !uploadingFields.has(entry.field)">Sin archivo</span>
                  <span class="doc-sub uploading" *ngIf="uploadingFields.has(entry.field)"
                    ><i class="fa-solid fa-spinner fa-spin"></i> Subiendo…</span
                  >
                  <span class="doc-sub reject-note" *ngIf="isRejected(getSingle(entry.field))">
                    <i class="fa-solid fa-comment-slash"></i> {{ getSingle(entry.field).rejectionReason }}
                    <ng-container *ngIf="getSingle(entry.field).reviewedByName">
                      · Revisó: {{ getSingle(entry.field).reviewedByName }}</ng-container
                    >
                  </span>
                </div>
              </div>

              <div class="row-meta">
                <span
                  class="review-chip pending"
                  *ngIf="isPending(getSingle(entry.field))"
                  [title]="uploadedByTooltip(getSingle(entry.field)) || 'En espera de revisión'"
                >
                  <i class="fa-solid fa-hourglass-half"></i> Por aprobar
                </span>
                <span
                  class="review-chip rejected"
                  *ngIf="isRejected(getSingle(entry.field))"
                  [title]="uploadedByTooltip(getSingle(entry.field)) || 'Documento rechazado'"
                >
                  <i class="fa-solid fa-circle-xmark"></i> Rechazado
                </span>
                <span
                  class="review-chip approved"
                  *ngIf="approvedByLabel(getSingle(entry.field)) as label"
                  [title]="approvedByTitle(getSingle(entry.field))"
                >
                  <i class="fa-solid fa-circle-check"></i> {{ label }}
                </span>
                <span
                  class="prov-chip"
                  *ngIf="provenanceOf(getSingle(entry.field)) as folio"
                  [title]="'Cargado desde el arrendamiento ' + folio"
                >
                  <i class="fa-solid fa-building"></i> {{ folio }}
                </span>
                <span class="due-chip" *ngIf="dueInfo(entry.field) as d" [class.overdue]="d.overdue">
                  <i class="fa-regular" [ngClass]="d.overdue ? 'fa-calendar-xmark' : 'fa-calendar-check'"></i>
                  {{ d.date | date: 'dd/MM/yyyy' }}
                </span>
                <p-dropdown
                  *ngIf="isClientContext && canEditInterval && getSingle(entry.field).url"
                  [options]="intervalOptions"
                  optionLabel="label"
                  optionValue="value"
                  [ngModel]="getInterval(entry.field)"
                  (onChange)="onIntervalChange(entry.field, $event.value)"
                  styleClass="interval-dd"
                  placeholder="Vigencia"
                  appendTo="body"
                ></p-dropdown>
              </div>

              <div class="row-actions">
                <ng-container *ngIf="getSingle(entry.field).url; else uploadSingle">
                  <button
                    class="act approve"
                    *ngIf="canReviewFile(getSingle(entry.field))"
                    title="Aprobar documento"
                    [disabled]="reviewBusy"
                    (click)="approveFile(entry.field, 0, getSingle(entry.field).url)"
                  >
                    <i class="fa-solid fa-check"></i>
                  </button>
                  <button
                    class="act reject"
                    *ngIf="canReviewFile(getSingle(entry.field))"
                    title="Rechazar documento"
                    [disabled]="reviewBusy"
                    (click)="openReject(entry.field, 0, getSingle(entry.field).url)"
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                  <button class="act" title="Previsualizar" (click)="openPreview(getSingle(entry.field))">
                    <i class="fa-solid fa-eye"></i>
                  </button>
                  <button class="act" title="Descargar" (click)="download(getSingle(entry.field))">
                    <i class="fa-solid fa-download"></i>
                  </button>
                  <ng-container *ngIf="isClientContext">
                    <button
                      class="act"
                      *ngIf="canEditInterval"
                      title="Renombrar"
                      (click)="openRename(entry.field, 0, getSingle(entry.field))"
                    >
                      <i class="fa-solid fa-pen"></i>
                    </button>
                    <button class="act" title="Cambiar" (click)="triggerUpload(entry.field, false)">
                      <i class="fa-solid fa-rotate"></i>
                    </button>
                    <button class="act danger" title="Eliminar" (click)="deleteSingle(entry.field)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </ng-container>
                </ng-container>
                <ng-template #uploadSingle>
                  <button class="act-upload" *ngIf="isClientContext" (click)="triggerUpload(entry.field, false)">
                    <i class="fa-solid fa-arrow-up-from-bracket"></i> Subir
                  </button>
                </ng-template>
              </div>
            </div>

            <!-- ARRAY (multi-archivo, vigencia por archivo) -->
            <div class="doc-group" *ngIf="entry.isArray">
              <div class="doc-row group-head">
                <div class="row-left">
                  <span class="doc-icon"><i class="fa-solid fa-layer-group"></i></span>
                  <div class="row-text">
                    <span class="doc-name">{{ entry.label }}</span>
                    <span class="doc-sub muted">{{ getArray(entry.field).length }} archivo(s)</span>
                  </div>
                </div>
                <div class="row-actions">
                  <span class="doc-sub uploading" *ngIf="uploadingFields.has(entry.field)"
                    ><i class="fa-solid fa-spinner fa-spin"></i
                  ></span>
                  <button class="act-upload" *ngIf="isClientContext" (click)="triggerUpload(entry.field, true)">
                    <i class="fa-solid fa-plus"></i> Agregar
                  </button>
                </div>
              </div>
              <ng-container *ngFor="let f of getArray(entry.field); let i = index">
                <div class="doc-subrow" [class.overdue]="dueInfoFile(f)?.overdue" [class.rejected]="isRejected(f)">
                  <span class="file-mini"><i class="fa-solid" [ngClass]="fileIcon(f.url)"></i></span>
                  <span class="file-name" [title]="uploadedByTooltip(f) || displayName(f)">{{ displayName(f) }}</span>
                  <span class="review-chip pending" *ngIf="isPending(f)" [title]="uploadedByTooltip(f) || 'En espera de revisión'">
                    <i class="fa-solid fa-hourglass-half"></i> Por aprobar
                  </span>
                  <span class="review-chip rejected" *ngIf="isRejected(f)" [title]="uploadedByTooltip(f) || 'Documento rechazado'">
                    <i class="fa-solid fa-circle-xmark"></i> Rechazado
                  </span>
                  <span class="review-chip approved" *ngIf="approvedByLabel(f) as label" [title]="approvedByTitle(f)">
                    <i class="fa-solid fa-circle-check"></i> {{ label }}
                  </span>
                  <span class="prov-chip" *ngIf="provenanceOf(f) as folio" [title]="'Cargado desde el arrendamiento ' + folio">
                    <i class="fa-solid fa-building"></i> {{ folio }}
                  </span>
                  <span class="due-chip" *ngIf="dueInfoFile(f) as d" [class.overdue]="d.overdue">
                    <i class="fa-regular" [ngClass]="d.overdue ? 'fa-calendar-xmark' : 'fa-calendar-check'"></i>
                    {{ d.date | date: 'dd/MM/yyyy' }}
                  </span>
                  <p-dropdown
                    *ngIf="isClientContext && canEditInterval && f.url"
                    [options]="intervalOptions"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="f.refreshInterval"
                    (onChange)="onArrayIntervalChange(entry.field, i, $event.value)"
                    styleClass="interval-dd"
                    placeholder="Vigencia"
                    appendTo="body"
                  ></p-dropdown>
                  <div class="row-actions">
                    <button
                      class="act approve"
                      *ngIf="canReviewFile(f)"
                      title="Aprobar documento"
                      [disabled]="reviewBusy"
                      (click)="approveFile(entry.field, i, f.url)"
                    >
                      <i class="fa-solid fa-check"></i>
                    </button>
                    <button
                      class="act reject"
                      *ngIf="canReviewFile(f)"
                      title="Rechazar documento"
                      [disabled]="reviewBusy"
                      (click)="openReject(entry.field, i, f.url)"
                    >
                      <i class="fa-solid fa-xmark"></i>
                    </button>
                    <button class="act" title="Previsualizar" (click)="openPreview(f)"><i class="fa-solid fa-eye"></i></button>
                    <button class="act" title="Descargar" (click)="download(f)"><i class="fa-solid fa-download"></i></button>
                    <ng-container *ngIf="isClientContext">
                      <button class="act" *ngIf="canEditInterval" title="Renombrar" (click)="openRename(entry.field, i, f)">
                        <i class="fa-solid fa-pen"></i>
                      </button>
                      <button class="act danger" title="Eliminar" (click)="deleteArrayItem(entry.field, f.url)">
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </ng-container>
                  </div>
                </div>
                <div class="copy-note-row" *ngIf="!isClientContext && f.url">
                  <i class="fa-solid fa-copy"></i>
                  <span>{{ copyNote(f) }}</span>
                </div>
                <div class="reject-note-row" *ngIf="isRejected(f)">
                  <i class="fa-solid fa-comment-slash"></i>
                  <span
                    >{{ f.rejectionReason }}<ng-container *ngIf="f.reviewedByName"> · Revisó: {{ f.reviewedByName }}</ng-container></span
                  >
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #loadingTpl>
    <div class="info-card docs-loading"><i class="fa-solid fa-spinner fa-spin"></i> Cargando catálogo…</div>
  </ng-template>
</div>

<!-- Visor de archivos -->
<app-file-preview-dialog
  [(visible)]="previewVisible"
  [fileUrl]="previewUrl"
  [fileName]="previewName"
  (downloadRequested)="downloadPreview()"
></app-file-preview-dialog>

<!-- Diálogos de escritura: solo existen en el expediente del cliente -->
<ng-container *ngIf="isClientContext">
  <!-- Confirmación (estilo plataforma) -->
  <p-dialog [(visible)]="showConfirm" [modal]="true" [closable]="false" [draggable]="false" header="Confirmar" [style]="{ width: '420px' }">
    <div class="flex align-items-center gap-3">
      <i class="fa-solid fa-triangle-exclamation" style="font-size: 1.4rem; color: #f97316"></i>
      <span>{{ confirmMessage }}</span>
    </div>
    <ng-template pTemplate="footer">
      <button
        pButton
        type="button"
        label="Cancelar"
        icon="pi pi-times"
        class="p-button-outlined p-button-danger"
        (click)="showConfirm = false"
      ></button>
      <button
        pButton
        type="button"
        label="Confirmar"
        icon="pi pi-check"
        class="p-button-outlined p-button-success"
        (click)="doConfirm()"
      ></button>
    </ng-template>
  </p-dialog>

  <!-- Prompt: marcar vigencia tras subir -->
  <p-dialog [(visible)]="showIntervalPrompt" [modal]="true" [closable]="true" header="Vigencia del documento" [style]="{ width: '420px' }">
    <p class="prompt-text">¿Cada cuánto debe reactualizarse este documento?</p>
    <div class="interval-choices">
      <button class="choice" (click)="setIntervalFromPrompt(null)">No requiere</button>
      <button class="choice" (click)="setIntervalFromPrompt('1m')">Cada 1 mes</button>
      <button class="choice" (click)="setIntervalFromPrompt('3m')">Cada 3 meses</button>
      <button class="choice" (click)="setIntervalFromPrompt('1y')">Cada 1 año</button>
    </div>
  </p-dialog>

  <!-- Modal agregar aval -->
  <p-dialog
    [(visible)]="showAddGuarantor"
    [modal]="true"
    [closable]="true"
    header="Agregar aval / obligado solidario"
    [style]="{ width: '440px' }"
  >
    <div class="add-aval-form">
      <label>Tipo</label>
      <p-selectButton
        [options]="guarantorTypeOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="newGuarantorType"
      ></p-selectButton>
      <small class="hint" *ngIf="guarantorRequestHint as hint">{{ hint }}</small>
      <label class="mt">Nombre o razón social (opcional)</label>
      <input pInputText type="text" [(ngModel)]="newGuarantorName" placeholder="Nombre del aval" />
    </div>
    <ng-template pTemplate="footer">
      <button pButton type="button" label="Cancelar" class="p-button-text" (click)="showAddGuarantor = false"></button>
      <button pButton type="button" label="Agregar" icon="fa-solid fa-check" [disabled]="saving" (click)="confirmAddGuarantor()"></button>
    </ng-template>
  </p-dialog>

  <!-- Modal rechazar documento (motivo obligatorio) -->
  <p-dialog
    [(visible)]="showRejectDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    header="Rechazar documento"
    [style]="{ width: '460px' }"
  >
    <div class="reject-form">
      <p class="prompt-text">
        El archivo quedará marcado como <strong>rechazado</strong> y no formará parte del expediente oficial. Indica el motivo para que
        quien lo subió pueda corregirlo.
      </p>
      <label for="rejectReason">Motivo del rechazo <span class="req">*</span></label>
      <textarea
        id="rejectReason"
        rows="4"
        maxlength="500"
        [(ngModel)]="rejectReason"
        placeholder="Ej. El documento está incompleto o ilegible…"
      ></textarea>
      <small class="hint">{{ rejectReason.length }}/500</small>
    </div>
    <ng-template pTemplate="footer">
      <button pButton type="button" label="Cancelar" class="p-button-text" (click)="showRejectDialog = false"></button>
      <button
        pButton
        type="button"
        label="Rechazar"
        icon="fa-solid fa-xmark"
        class="p-button-danger"
        [disabled]="reviewBusy || !rejectReason.trim()"
        (click)="confirmReject()"
      ></button>
    </ng-template>
  </p-dialog>

  <!-- Modal renombrar archivo (solo cambia el nombre visible, nunca la URL) -->
  <p-dialog
    [(visible)]="showRenameDialog"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    header="Renombrar archivo"
    [style]="{ width: '440px' }"
  >
    <div class="rename-form">
      <label for="renameValue">Nombre del archivo</label>
      <input pInputText id="renameValue" type="text" maxlength="200" [(ngModel)]="renameValue" placeholder="Nombre visible del archivo" />
      <small class="hint">Solo cambia el nombre con el que se muestra; el archivo no se modifica.</small>
    </div>
    <ng-template pTemplate="footer">
      <button pButton type="button" label="Cancelar" class="p-button-text" (click)="showRenameDialog = false"></button>
      <button
        pButton
        type="button"
        label="Guardar"
        icon="fa-solid fa-check"
        [disabled]="saving || !renameValue.trim()"
        (click)="confirmRename()"
      ></button>
    </ng-template>
  </p-dialog>
</ng-container>
